import { render, staticRenderFns } from "./POSList.vue?vue&type=template&id=f988a49e&"
import script from "./POSList.vue?vue&type=script&lang=js&"
export * from "./POSList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports